import AmbienteCadastro from '../Paginas/Privadas/Ambientes/AmbienteCadastro';
import AmbienteLista from '../Paginas/Privadas/Ambientes/AmbienteLista';
import AtuadorCadastro from '../Paginas/Privadas/Atuadores/AtuadorCadastro';
import AtuadoresLista from '../Paginas/Privadas/Atuadores/AtuadoresLista';
import Configuracoes from '../Paginas/Privadas/Configuracoes';
import DadosCadastrais from '../Paginas/Privadas/DadosCadastrais';
import Dashboard from '../Paginas/Privadas/Dashboard/Dashboard';
import DashBoardAmbiente from '../Paginas/Privadas/Dashboard/DashBoardAmbiente';
import DashboardDetalhes from '../Paginas/Privadas/Dashboard/DashboardDetalhes';
import DesumidificadorCadastro from '../Paginas/Privadas/Desumidificadores/DesumidificadorCadastro';
import DesumidificadorLista from '../Paginas/Privadas/Desumidificadores/DesumidificadorLista';
import ListaAlertas from '../Paginas/Privadas/Alertas/ListaAlertas';
import AlertaCadastro from '../Paginas/Privadas/Alertas/AlertaCadastro';
import SensoresCadastro from '../Paginas/Privadas/Sensores/SensoresCadastro';
import SensoresLista from '../Paginas/Privadas/Sensores/SensoresLista';
import UsuarioCadastro from '../Paginas/Privadas/Usuarios/UsuarioCadastro';
import UsuariosLista from '../Paginas/Privadas/Usuarios/UsuariosLista';
import Wellcome from '../Paginas/Privadas/Wellcome';
import DashboardCard from '../Paginas/Privadas/Dashboard/DashboardCard';
import ListaRelatorio from '../Paginas/Privadas/Relatorios/ListaRelatorio';

const Paginas = [
  { caminho: '/wellcome', tag: 'Geral', elemento: <Wellcome /> },
  { caminho: '/DadosCadastrais', tag: 'Geral', elemento: <DadosCadastrais /> },
  { caminho: '/sensors', tag: 'sensor', elemento: <SensoresLista /> },
  { caminho: '/sensor-form', tag: 'sensor-form', elemento: <SensoresCadastro /> },
  { caminho: '/sensor-form/:id', tag: 'sensor-form', elemento: <SensoresCadastro /> },
  { caminho: '/users', tag: 'user', elemento: <UsuariosLista /> },
  { caminho: '/user-form', tag: 'user-form', elemento: <UsuarioCadastro /> },
  { caminho: '/user-form/:id', tag: 'user-form', elemento: <UsuarioCadastro /> },
  { caminho: '/my-data', tag: 'user-form', elemento: <UsuarioCadastro myData={true} /> },
  { caminho: '/actuators', tag: 'actuator', elemento: <AtuadoresLista /> },
  { caminho: '/actuator-form', tag: 'actuator-form', elemento: <AtuadorCadastro /> },
  { caminho: '/actuator-form/:id', tag: 'actuator-form', elemento: <AtuadorCadastro /> },
  { caminho: '/SensoresCadastro', tag: 'Sensor', elemento: <SensoresCadastro /> },
  { caminho: '/dehumidifier', tag: 'dehumidifier', elemento: <DesumidificadorLista /> },
  {
    caminho: '/dehumidifier-form',
    tag: 'dehumidifier-form',
    elemento: <DesumidificadorCadastro />,
  },
  {
    caminho: '/dehumidifier-form/:id',
    tag: 'dehumidifier-form',
    elemento: <DesumidificadorCadastro />,
  },
  { caminho: '/alerts', tag: 'Alertas', elemento: <ListaAlertas /> },
  { caminho: '/alert-form/:id', tag: 'alert-form', elemento: <AlertaCadastro /> },
  { caminho: '/Dashboard', tag: 'Dashboard', elemento: <Dashboard /> },
  { caminho: '/DashboardAmbiente', tag: 'Dashboard', elemento: <DashBoardAmbiente /> },
  { caminho: '/DashboardCard', tag: 'Dashboard', elemento: <DashboardCard /> },
  { caminho: '/Geladeira/:id', tag: 'Dashboard', elemento: <DashboardDetalhes /> },
  { caminho: '/Configuracoes', tag: 'Configuracoes', elemento: <Configuracoes /> },
  { caminho: '/Ambientes', tag: 'Ambiente', elemento: <AmbienteLista /> },
  { caminho: '/AmbienteCadastro', tag: 'Ambiente', elemento: <AmbienteCadastro /> },
  { caminho: '/environment-form/:id', tag: 'environment-form', elemento: <AmbienteCadastro /> },
  { caminho: '/report', tag: 'Relatório', elemento: <ListaRelatorio /> },
];

export default Paginas;
